export default "__VITE_ASSET__Dq1OfopG__"